import PostalKit from '../../ports-frontend/PostalKit';

export async function headerWatcher({ callback }: { callback: Function }) {
  const unsubscribeHamburgerClick = await PostalKit.onSubscribe(
    async (payload: { event: string; payload: any }) => {
      if (payload.event === 'pam.callback.hamburger.clicked') {
        return callback({
          type: 'VIEW_HAMBURGER_MENU_CLICK',
          payload: {
            command: 'leftSLider',
          },
        });
      }
    },
    ['events', 'pam']
  );

  const unsubscribeTrackingEvent = await PostalKit.onSubscribe(
    async (payload: { event: string; payload: any }) => {
      return callback({
        type: 'VIEW_PARTIAL_EVENT_CALLED',
        payload: payload,
      });
    },
    ['tracking', 'pam']
  );

  return () => {
    unsubscribeHamburgerClick();
    unsubscribeTrackingEvent();
  };
}
